import { FC } from 'react';

import Image, { ImageProps } from 'next/image';
import Link from 'next/link';

import STATIC_ROUTES from '@data/staticRoutes.json';
import { APP_STATIC } from '@config/app-static';

interface IBrandLink {
  imageProps?: Partial<ImageProps>;
}

const BrandLink: FC<IBrandLink> = ({ imageProps }) => {
  return (
    <Link prefetch={false} href={STATIC_ROUTES.home} data-testid='garanti-logo'>
      <Image
        src={APP_STATIC.app_logo}
        height={40}
        width={112}
        alt='Garanti Logo'
        priority
        {...imageProps}
      />
    </Link>
  );
};

export default BrandLink;
